import Layout from 'common/layout/Layout';
import TopicPage from './TopicPage';

const FundManagerPage = () => {
  return (
    <Layout>
      <TopicPage topicUserType="for_fund_manager" />
    </Layout>
  );
};

export default FundManagerPage;
